export const isNativeAudioNode = (nativeAudioNodeOrAudioParam) => {
    return (nativeAudioNodeOrAudioParam.context !== undefined);
};
//# sourceMappingURL=/build/es2018/guards/native-audio-node.js.map